export function getSavedAddressLine(address) {
  if (!address) {
    return '';
  }

  return address.address || address.fullAddress || address.addressLine1 || '';
}

export function getOrderAddressLine(shippingAddress) {
  if (!shippingAddress) {
    return '';
  }

  if (shippingAddress.fullAddress) {
    return shippingAddress.fullAddress;
  }

  return [shippingAddress.addressLine1, shippingAddress.city, shippingAddress.state, shippingAddress.country]
    .filter(Boolean)
    .join(', ');
}
